import React,{useState,useEffect} from "react";
import { useDispatch } from "react-redux";

import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import { Bookmark, ClipboardX, CloudDownload, Donut, EllipsisVertical, Expand, FileCheck2, FolderPlus } from "lucide-react";
import UniversalVideoPlayer from "../../CreateWebsite/VideoPlayer/UniversalVideoPlayerWebUI";


const QuickViewItemCard =({getFileObject,setCloseQuickViewPopUp,item,setQuickViewItem,downloadFileClick,videoSettingsObject})=>{
    
        const [active , setActive] = useState({status:false});

        function formatSize(obj){
            // Convert bytes to human-readable size
  const bytes = obj ?? 0;
  const units = ["B", "KB", "MB", "GB", "TB"];
  let size = bytes;
  let unitIndex = 0;

  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex++;
  }

  return `${size.toFixed(1)} ${units[unitIndex]}`;

        }
function formatDateTime(obj) {
  const dateStr = obj?.replace(" ", "T"); // make it ISO compatible
  const date = new Date(dateStr);

  if (isNaN(date)) return "Invalid date";

  const options = {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  return date.toLocaleString("en-US", options);
}
       
        const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
                     const [isLoaded, setIsLoaded] = useState(false);
                     const [hasError, setHasError] = useState(false);
                     
                        
                             const [reloadItems, setReloadItems] = useState(true);
                            
                                useEffect(()=>{
                                    setReloadItems(false); setReloadItems(true);
                                    
                                },[ ])
                   
                                  
                     return (
                       <div style={{ position: "relative",boxShadow:boxShadow,
                       
                                   
                       maxWidth:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
                         {!isLoaded && !hasError && (
                           <div
                            style={
                                { 
                                   position: "absolute",
                         top: 0,
                         left: 0,
                         maxWidth: `${width}%`,
                          }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                           >
                             <img
                           src={loading_img}
                           alt=""
                         
                          style={
                                {
                                
                                   position: "absolute",border:border,
                         top: 0,
                         left: 0,
                         maxWidth: `${width}%`,padding:"10px",
                          }}
                          className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
                         />
                           </div>
                         )}
                         
                         <img
                   
                         
                           src={hasError ? fallback_img : src}
                           alt=""
                           onLoad={() => setIsLoaded(true)}
                           onError={() => setHasError(true)}
                          style={
                                {
                                   position: "absolute",
                         top: 0,
                         left: 0,
                         maxWidth: `${width}%`,
                          }}
                        
                         />
                       
                       </div>
                     );
                   };  
   return(<>
 <div    onClick={()=>setCloseQuickViewPopUp(false)} className="PopUpQuickViewOpacityQuickView"  style={{cursor:"pointer"}}> </div>
        <div   className="PopUpQuickView" style={{borderRadius: '0px'}}> 
        <h2 align="center" >   <span className="" style={{fontSize:"34px"}} >QuickView </span> </h2>
      
 
<div className="PopUpQuickViewHeight" style={{display:"flex",justifyContent:"center"}}>
    <div  style={{width:"99%",position:"relative"}}>
        <div className="" >
                <div className="QVopenInfoOuter" style={{cursor:"pointer",width:"25px",height:"25px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"rgba(144, 202, 249,1)",position:"absolute",right:"5px",top:"5px",zIndex:"99999"}}>
        <EllipsisVertical size={15} color={"#ffffff"} />
        <div className="QVopenInfoInner">
         
            <div className="QVopenInfoInnerItem">
             <label className={"checkbox-outer  "}  style={{marginTop:"-5px",marginLeft:"-5px"}}>
                                                
                                                <span style={{position:"relative",top: "-1px" ,left:"-2px",fontSize:"14px",textTransform: "capitalize"}}>{active?.status?"Deselect":"Select"} {item?.mime_type}</span>
                                               
                                                        <input  type={"checkbox"} title={item?.file_name}
                                                         className="input-textbox"  checked= {active?.status} value={item?.file_s3_key} name={"selectFile"}  
             onChange={e=>{ setActive({...active,status:!active.status});getFileObject(item)
                
                
               }
               
            }
            />
                                                           <span class={"square"} style={{border:"3px solid rgba(144, 202, 249,1)",transform:"scale(0.6)",borderRadius:"5px",}}></span>
                                                  </label>
                                                   
            </div>
            <div onClick={()=>{downloadFileClick(item);}} className="QVopenInfoInnerItem">
             <CloudDownload size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Download</span>
            </div> <div onClick={()=>{setQuickViewItem(item)}} className="QVopenInfoInnerItem">
             <FolderPlus size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Add To List</span>
            </div> <div className="QVopenInfoInnerItem">
             <ClipboardX size={20}  color="rgba(144, 202, 249,1)" /> <span style={{fontSize:"14px"}}>Move To Trash</span>
            </div>
        </div>
               </div> {item?.mime_type=="image"?
 <ImageFallFB  boxShadow={``}
                      src={item?.fileUrl}
                      border={{}}
                      width={ 100
                      }
                      aspectRatio={1}
                      borderRadius={ {}
                      }/>:item?.mime_type=="video"?<div style={{marginTop:"30px"}}>
                      <UniversalVideoPlayer  videoSettings={videoSettingsObject} videoUrl={item?.fileUrl} minHeight={380} maxHeight={420}/></div>:""}
                      
                      
                   </div>
         </div> </div> 
<div align="center" className="" style={{position:"absolute",left:"0px",right:"0px",bottom:"10px",display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',flexWrap:"wrap"
 }}>
  <div  style={{display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',background:"#ffffff",padding:"10px",width:"99%",
 }}>
    <div><h4>File Name: {item?.file_name}</h4>
    <div style={{background:"rgba(144, 202, 249,0.51)",borderRadius:"5px",padding:"5px"}}>File Type:
        <span style={{textTransform:"capitalize"}}> {item?.mime_type}</span>  &bull; Size: {formatSize(item?.size)}  &bull; {formatDateTime(item?.created_at)}</div>
    </div>
    
    </div>     
<div  style={{display:"flex",justifyContent:"space-between",alignContent:"center",textAlign:"center",gap:"10px",margin:"5px",
   
   transition: 'transform 2s ease, opacity 1s ease',width:"99%",
 }}>
                        <div onClick={()=>{downloadFileClick(item);}} className="openInfoOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"125px",height:"25px",display:"flex",justifyContent:"center",alignItems:"center",gap:"10px",borderRadius:"5px",background:"#ffffff",}}>
<CloudDownload size={18} color={"rgba(144, 202, 249,1)"} /> Download
</div> 
 <div onClick={()=>{setQuickViewItem(item)}} className="openInfoOuter" style={{border:"2px solid rgba(144, 202, 249,1)",cursor:"pointer",width:"130px",height:"30px",display:"flex",justifyContent:"center",alignItems:"center",gap:"10px",borderRadius:"50px",background:"#ffffff",zIndex:"99"}}>
<Bookmark size={18} color={"rgba(144, 202, 249,1)"} /> Add to List
</div></div>

</div> 
</div>
<style>{`

 .QVopenInfoInnerItem{height:20px;cursor:pointer;display:flex;justify-content:left;gap:8px;background:#fff;padding:3px 5px;border-radius:5px;margin-bottom:5px}
    .QVopenInfoOuter .QVopenInfoInner{border:2px solid rgba(144, 202, 249,1);width:125px;height:120px;background:rgba(228, 237, 244, 1);;border-radius:5px;position:absolute;top:0px;right:33px;visibility:hidden;opacity:0;transition: 0.1s ease;}
     .QVopenInfoOuter:hover .QVopenInfoInner{visibility:visible;opacity:1;transition: 0.1s ease;padding:5px}
    .fileCardOuter{ position:relative;
    background:rgba(144, 202, 249,0.1);
    min-width:160px;padding:5px;
    border:3px solid rgba(144, 202, 249,1);transform:scale(1);transition: 0.1s ease;
    min-height:105px;border-radius:10px;margin-bottom:20px;
    }
   .QVopenInfoInner::after {
    content: "";
    position: absolute;
   top: 0px;
    right: -16px;
    margin-left: 2px;
    border-width: 8px;
    border-style: solid;
    border-color:  transparent  transparent   transparent rgba(144, 202, 249,1) ;
  }
    .QVopenInfoInnerItem:hover{transform:scale(0.9);transition: 0.1s ease;}


 .mockTestQuickViewTextbox, .mockTestQuickViewTextbox:hover, .mockTestQuickViewTextbox:focus{
    background: #f9f9f9;
    box-shadow:var(--shadow-default);
   color:#222;
   padding: 15px;
   margin:10px;outline: #fff;
   border: 3px solid rgba(144, 202, 249,1) !important;
   border-radius: 10px;;
}
  .PopUpQuickViewHeight{overflow-y:auto;height:400px;padding:3px;padding-bottom:50px;}
.MocktestQuickViewBtn{ 
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.0501);
    font-size: 14px;;cursor: pointer;
    color:rgba(149, 143, 218,0.8);
font-weight:600 !important;width:95px;float: right ;
   cursor: pointer;
padding: 9px 5px ;
font-weight:600 !important;
 border:0px dashed #ffffff ;
    margin:15px;;
    background:#ffffff;border-radius: 10px;;
    text-align: center;
   }
  
.mockTestColoredTextV1QuickView {
         animation: background-pan-b24b2865 0.9s linear infinite;
        animation-duration: 0.9s;
        animation-timing-function: linear;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        animation-direction: normal;
        animation-fill-mode: none;
        animation-play-state: running;
        animation-name: background-pan-b24b2865;
 
        animation-timeline: auto;
        animation-range-start: normal;
        animation-range-end: normal;
        background: linear-gradient(to right, #8142e3, #86c2ff);
        -webkit-background-clip: text;
        background-size: 200%;
        -webkit-text-fill-color: transparent;
    }
.PopUpQuickViewOpacityQuickView{position:fixed;top:0px;
        left:0px;
        right:0px;
       
        bottom:0px;
        padding:5px;
        background: rgba(20, 20, 20, 0.1);;
        z-index:9999999999 !important}
        
        .PopUpQuickView{position:fixed;
    left:20%;
    right:20%;
    background: #ffffff;
    top:0%;bottom:0%;
    padding:5px;
    z-index:99999999999 !important;}

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
 .PopUpQuickViewHeight{height:60vh;}
    .PopUpQuickView{position:fixed;top:0px;
        left:10%;
        right:10%;top:10%;bottom:10%;
       }}

      /* sm */
@media (min-width: 768px) and (max-width: 991px) {
.PopUpQuickViewHeight{height:60vh;}
  .PopUpQuickView{position:fixed;top:0px;
                left:10%;
                right:10%;top:10%;bottom:10%;
               }} 

/* xs */
@media (max-width: 767px) {
    .PopUpQuickViewHeight{height:70vh;}
    .PopUpQuickView{
       
        top:0px!important; height:100% !important;
        left:0%;border-radius: 0px !important;
        right:0%;
        bottom:0%!important;
    }
        }
        `}</style>
    </>)
}
export default QuickViewItemCard;